export const SUPPORTED_LANGUAGES = [
  { label: 'English', value: 'en-GB', flag: '🇬🇧' },
  { label: '中文', value: 'zh-CN', flag: '🇨🇳' },
] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]['value']
